export const PAYMENT_LINK =
  'https://pay.hotmart.com/Q104942988G?checkoutMode=10'
export const META_PIXEL_ID = '1225428543097695'

export const IMAGES = {
  TOMO_1:
    'https://cdn.magicpatterns.com/uploads/aeb8279YS8MckFDHboRYJ3/tomo_1.png',
  TOMO_2:
    'https://cdn.magicpatterns.com/uploads/9tmqysqfZfunEAeVKyGz7Z/tomo_2.png',
  TOMO_3:
    'https://cdn.magicpatterns.com/uploads/dwgHJhxLS8c8JCzBpfd6S6/tomo_3.png',
  TOMO_5:
    'https://cdn.magicpatterns.com/uploads/aTPBPDfYK1uG579hdwZwgL/tomo_5.png',
}

export const COUNTDOWN_INITIAL = 643 // 10 minutes 43 seconds

export const PRICES = {
  original: '79,99 €',
  sale: '15,99 €',
  totalValue: '130,95 €',
  savings: '80%',
}

export const PURCHASE_NAMES = [
  { name: 'Luca', city: 'Firenze' },
  { name: 'Martina', city: 'Verona' },
  { name: 'Alessio', city: 'Palermo' },
  { name: 'Serena', city: 'Bari' },
  { name: 'Andrea', city: 'Genova' },
  { name: 'Chiara', city: 'Padova' },
  { name: 'Matteo', city: 'Catania' },
  { name: 'Silvia', city: 'Parma' },
  { name: 'Federico', city: 'Perugia' },
  { name: 'Valentina', city: 'Trieste' },
  { name: 'Paolo', city: 'Modena' },
  { name: 'Laura', city: 'Venezia' },
]
